import React from "react";
import { Box, Card, Typography } from "@mui/material";
import logo from "../../../resources/images/svg/inexplore-logo-white.svg";
import { CheckRounded } from "@mui/icons-material";
import InexButton from "../../InexButton";
import PriceFormater from "../../PriceFormater";
import { useIsMobile } from "../../../hooks/responsive";


const redirectToSubscribe = () => {
	window.open(`https://abonnements.inexplore.com/je-mabonne?selectedAbos=[3,4]`, "_blank").focus();
};

const SubscriptionBulletPoint = ({ title, subTitle, sx }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        ...sx,
      }}
    >
      <CheckRounded
        color={"success"}
        sx={{
          mr: 1,
        }}
      />
      <Typography
        sx={{
          fontWeight: 700,
        }}
      >
        <span
          style={{
            color: "#FC7D06",
            fontWeight: 700,
          }}
        >
          {title}
        </span>
        {subTitle}
      </Typography>
    </Box>
  );
};

const SubscribeCard = () => {

  const isMobile = useIsMobile();

  return (
    <Card
      sx={{
        display: "flex",
        background: (theme) => theme.palette.blackPro,
        borderRadius: "20px",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        padding: 5,
        maxWidth: isMobile ? undefined : "600px",
        transition: "transform 0.2s",
        "&:hover": {
          transform: "scale(1.01)",
        },
      }}
    >
      <img
        src={logo}
        className=""
        alt="logo"
        style={{
          width: "300px",
        }}
      />
      <Box
        sx={{
          mt: 3,
          mb: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "500",
            margin: 0,
          }}
        >
          L’abonnement Inexploré Praticiens vous donne accès à :
        </Typography>
      </Box>

      <SubscriptionBulletPoint
        title={"Un contenu éditorial dédié "}
        subTitle={": vidéos et podcasts conçus spécialement pour les praticiens."}
        sx={{
          mb: 1,
        }}
      />
      <SubscriptionBulletPoint
        title={"Inexploré TV "}
        subTitle={": l’intégralité de nos documentaires"}
        sx={{
          mb: 1,
        }}
      />
      <SubscriptionBulletPoint
        title={"Inexploré digital "}
        subTitle={": tous nos podcasts et articles, en accès illimité."}
        sx={{
          mb: 1,
        }}
      />
      <SubscriptionBulletPoint
        title={"Des événements exclusifs "}
        subTitle={": réservés aux professionnels (accès sur achat d’une place et signature de la charte)."}
        sx={{
          mb: 1,
        }}
      />


      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <PriceFormater
          price={1790}
          period={"Mensuel"}
          withTimeFrame={true}
          withTitle={false}
          priceProps={{
            sx: {
              color: "white",
              fontWeight: 700,
              fontSize: 55,
              lineHeight: "1.2em",
              fontFamily: "Branding Bold",
            },
          }}
          timeFrameProps={{
            sx: {
              color: "white",
              fontWeight: 700,
              fontSize: 25,
              fontFamily: "Branding Bold",
            },
          }}
        />
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            maxWidth: 450,
            mt: 1,
            mb: 1,
          }}
        >
         ou 179€ avec l'offre annuelle
        </Typography>
      </Box>

      <InexButton
        text={"Je m'abonne à Inexploré Praticiens"}
        variant={"text"}
        textWithGradient={false}
        onClick={redirectToSubscribe}
        sx={{
          zIndex: 1,
          marginBottom: 3,
          marginTop: 3,
          width: "80%",
          height: "50px",
          background: (theme) => theme.palette.yellowPro,
          transition: "background 0.3s ease-in-out",
          border: (theme) => theme.palette.yellowPro + " solid 3px",
          color: "#202020",
          "&:hover": {
            backgroundColor: "white",
            "& > p": {
              color: "#202020",
            },
          },
        }}
      />

    </Card>
  );
};

export default SubscribeCard;
